import { render, staticRenderFns } from "./EndorsementsTable.html?vue&type=template&id=71919896&"
import script from "./EndorsementsTable.component.js?vue&type=script&lang=js&"
export * from "./EndorsementsTable.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports